import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FileService } from 'src/app/services/file.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
import * as XLSX from 'xlsx';
declare var jQuery: any; 

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})
export class FilesComponent implements OnInit {

  public user: string;
  public types: string[] = ['USUARIOS', 'ARTICULOS', 'NOCS', 'PRECIOS', 'FAMILIAS'];//'STOCK'
  public typeSelect: string = '';
  @ViewChild('userModal') userModal: ModalDirective;
  @ViewChild('clothModal') clothModal: ModalDirective;
  @ViewChild('nocsModal') nocsModal: ModalDirective;
  @ViewChild('priceModal') priceModal: ModalDirective;
  @ViewChild('familyModal') familyModal: ModalDirective;
  constructor(
    private spinner: NgxSpinnerService, private toastr: ToastrService, 
    private router: Router, private fileService: FileService,
    private authService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.user = localStorage.getItem("nid");
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
    }
    this.spinner.hide();
  }

  submit(){
    this.spinner.show();
    if(this.typeSelect == null || this.typeSelect == undefined || this.typeSelect == ''){
      this.toastr.info("SELECCIONE TIPO");
      this.spinner.hide();
      return;
    }
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    const file = fileInput.files[0];

    if (!file) {
      this.toastr.info("AÑADA EL FICHERO");
      this.spinner.hide();
      return;
    }
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();

    if(this.typeSelect == 'USUARIOS'){
      const allowedExtensions = ['txt'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.toastr.info("TIPO DE ARCHIVO INCORRECTO (.txt)");
        this.spinner.hide();
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result as string;
          const base64Data = base64String.split(',')[1];
          this.fileService.usersFile(base64Data, this.user).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("FICHERO DE USUARIOS COMPLETADO");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresUsuarios.txt');
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        };
        reader.onerror = () => {
          this.toastr.error("ERROR AL LEER EL ARCHIVO");
          this.spinner.hide();
        };
      }
    }else if(this.typeSelect == 'ARTICULOS'){
      const allowedExtensions = ['xls', 'xlsx', 'csv'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.toastr.info("TIPO DE ARCHIVO INCORRECTO (.xls, .xlsx, .csv)");
        this.spinner.hide();
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result as string;
          const base64Data = base64String.split(',')[1];
          this.fileService.clothesFile(base64Data, this.user, fileExtension).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("FICHERO DE USUARIOS COMPLETADO");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresArticulos.txt');
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        };
        reader.onerror = () => {
          this.toastr.error("ERROR AL LEER EL ARCHIVO");
          this.spinner.hide();
        };
      }
    }else if(this.typeSelect == 'NOCS'){
      const allowedExtensions = ['xls', 'xlsx', 'csv'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.toastr.info("TIPO DE ARCHIVO INCORRECTO (.xls, .xlsx, .csv)");
        this.spinner.hide();
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result as string;
          const base64Data = base64String.split(',')[1];
          this.fileService.nocsFile(base64Data, this.user, fileExtension).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("FICHERO DE NOCS COMPLETADO");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresNocs.txt');
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        };
        reader.onerror = () => {
          this.toastr.error("ERROR AL LEER EL ARCHIVO");
          this.spinner.hide();
        };
      }
    }else if(this.typeSelect == 'PRECIOS'){
      //const allowedExtensions = ['xls', 'xlsx', 'csv'];
      const allowedExtensions = ['csv'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.toastr.info("TIPO DE ARCHIVO INCORRECTO (.csv)");
        this.spinner.hide();
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result as string;
          const base64Data = base64String.split(',')[1];
          this.fileService.pricesFile(base64Data, this.user, fileExtension).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("FICHERO DE PRECIOS COMPLETADO");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresPrecios.txt');
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        };
        reader.onerror = () => {
          this.toastr.error("ERROR AL LEER EL ARCHIVO");
          this.spinner.hide();
        };
      }
    }else if(this.typeSelect == 'FAMILIAS'){
      const allowedExtensions = ['xls', 'xlsx', 'csv'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.toastr.info("TIPO DE ARCHIVO INCORRECTO (.xls, .xlsx, .csv)");
        this.spinner.hide();
        return;
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result as string;
          const base64Data = base64String.split(',')[1];
          this.fileService.familiesFile(base64Data, this.user, fileExtension).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("FICHERO DE FAMILIAS COMPLETADO");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresFamilias.txt');
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        };
        reader.onerror = () => {
          this.toastr.error("ERROR AL LEER EL ARCHIVO");
          this.spinner.hide();
        };
      }
    }else if(this.typeSelect == 'STOCK'){
      const allowedExtensions = ['xls', 'xlsx'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.toastr.info("TIPO DE ARCHIVO INCORRECTO (.xls, .xlsx)");
        this.spinner.hide();
        return;
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          const bstr: string = reader.result as string;
          const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          this.fileService.updateStock(jsonData, this.user).subscribe(
            data => {
              if (getToken(data)) {
                this.toastr.success("FICHERO DE STOCK COMPLETADO");
              }
              if (data.errorFileBase64) {
                this.downloadTxtFile(data.errorFileBase64, 'erroresStock.txt');
              }
              if(data.errorCode){
                console.log(data)
                this.toastr.error(data.errorCode);
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.logOut();
            }
          );
        };
        reader.onerror = () => {
          this.toastr.error("ERROR AL LEER EL ARCHIVO");
          this.spinner.hide();
        };
        reader.readAsBinaryString(file);
      }
    }else{
      this.toastr.info("ERROR EN EL TIPO DE ARCHIVO");
      this.spinner.hide();
      return;
    }
  }

  downloadTxtFile(base64Content: string, fileName: string): void {
    const decodedContent = atob(base64Content);
    const blob = new Blob([decodedContent], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  openModal(){
    if(this.typeSelect == 'USUARIOS'){
      this.userModal.show();
    }else if(this.typeSelect == 'ARTICULOS'){
      this.clothModal.show();
    }else if(this.typeSelect == 'NOCS'){
      this.nocsModal.show();
    }else if(this.typeSelect == 'PRECIOS'){
      this.priceModal.show();
    }else if(this.typeSelect == 'FAMILIAS'){
      this.familyModal.show();
    }
  }
}
